/** Fallback Instant Quote widget button colour when an operator hasn't set one. */
export const DEFAULT_WIDGET_COLOR = "#5F3B6C";

/** RideMinder's own primary (RM Daisy UI Purple Main), where no operator's colour is known. */
export const DEFAULT_PRIMARY_COLOR = "#5F3B6C";
